"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmployeeFunctionsTableRows;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function EmployeeFunctionsTableRows(_ref) {
  let {
    dataRows
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dataRows.map((dataRow, i) => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, {
      className: "white-border",
      key: i,
      onClick: () => dataRow.onRowClick(dataRow)
    }, dataRow.cells.map(cell => {
      let {
        value,
        ...rest
      } = cell;
      return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, rest, value);
    }));
  }));
}